import { createSlice } from "@reduxjs/toolkit";

const nudgeSlice = createSlice({
    name: 'nudge',
    initialState: {

    },
    reducers: {


    }
})

export const { 

} = nudgeSlice.actions

export default nudgeSlice.reducer